import { Box } from "@mui/material";
import DOMPurify from "dompurify";
import { marked } from "marked";
import { useMemo } from "react";

/** Renders trusted-ish markdown (legal, docs, changelog) sanitized with DOMPurify. */
export function Markdown({ source }: { source: string }) {
  const html = useMemo(() => DOMPurify.sanitize(marked.parse(source, { async: false }) as string), [source]);
  return <Box className="markdown" sx={{ "& h1": { fontSize: "2rem" }, "& h2": { fontSize: "1.5rem", mt: 3 }, "& h3": { fontSize: "1.2rem", mt: 2 }, "& pre": { bgcolor: "action.hover", p: 2, borderRadius: 1, overflowX: "auto" }, "& code": { fontSize: "0.9em" }, "& table": { borderCollapse: "collapse", width: "100%" }, "& td, & th": { border: 1, borderColor: "divider", p: 1, textAlign: "left" }, "& a": { color: "primary.main" } }} dangerouslySetInnerHTML={{ __html: html }} />;
}
